/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Checkpoint_ExpiredInputs */



/**
* | output |
* | --- |
* | "This checkpoint is no longer available. Checkpoints are kept for 30 days on this device." |
*
* @param {Assistant_Checkpoint_ExpiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_checkpoint_expired = /** @type {((inputs?: Assistant_Checkpoint_ExpiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Checkpoint_ExpiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce point de contrôle n'est plus disponible. Les points de contrôle sont conservés pendant 30 jours sur cet appareil.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Checkpoint ist nicht mehr verfügbar. Checkpoints werden auf diesem Gerät 30 Tage lang gespeichert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo checkpoint non è più disponibile. I checkpoint vengono conservati su questo dispositivo per 30 giorni.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Данный контрольный пункт больше недоступен. Контрольные точки сохраняются на этом устройстве в течение 30 дней.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este punto de control ya no está disponible. Los puntos de control se conservan durante 30 días en este dispositivo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此检查点已失效。检查点在此设备上保留30天。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このチェックポイントは現在利用できません。このデバイスでは、チェックポイントは30日間保存されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह चेकपॉइंट अब उपलब्ध नहीं है। इस डिवाइस पर चेकपॉइंट 30 दिनों तक सुरक्षित रहते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Este ponto de verificação não está mais disponível. Os pontos de verificação são mantidos neste dispositivo por 30 dias.")
	return /** @type {LocalizedString} */ ("This checkpoint is no longer available. Checkpoints are kept for 30 days on this device.")
});